import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Document from '../../entities/document';
import Firm from '../../entities/firm';
import Identification from '../../entities/identification';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteDocument(): boolean {
return true;
}
export function collectDocumentDeleteImpact(document: Document, context: DeleteImpactContext): void {
const key = 'document:' + document.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const firmLogoImpact = workingRows<Firm>('firm', findAll<Firm>('firms')).filter(firmRef => firmRef.logo === document.id);
firmLogoImpact.forEach(firmRef => addDeleteImpact(context, 'firm:' + firmRef.id, 'firms'));
const identificationAttachmentsImpact = workingRows<Identification>('identification', findAll<Identification>('identifications')).filter(identificationRef => identificationRef.attachments?.includes(document.id));
identificationAttachmentsImpact.forEach(identificationRef => addDeleteImpact(context, 'identification:' + identificationRef.id, 'identifications'));}
export function deleteImpactDocument(document: Document): DeleteImpact {
const context = deleteImpactContext();
collectDocumentDeleteImpact(document, context);
return deleteImpactCounts(context);
}
export function deleteDocument(document: Document, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteDocument()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectDocumentDeleteImpact(document, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || document.id};
}
const key = 'document:' + document.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Firm>('firm', [...store.getState().firms.getMappingFor('logo', document.id)]).filter(firmTemp => firmTemp.logo === document.id).forEach(firmTemp => {
const _firm = ((_work.get('firm:' + firmTemp.id) ?? firmTemp) as Firm).clone();
if (_firm.status === 'D') return;
_firm.status = 'U';
_firm.addedOn = newHRTimestamp();
_firm.addedBy = getCurrentUserId();
_firm.importSource = targetImportSource;
_firm.importId = mergeId;
if (_firm.logo === document.id) {
_firm.logo = null;

}
_work.set('firm:' + _firm.id, _firm);
dispatch(Actions.FirmActions.saveFirmQueue(_firm), 'firm:' + _firm.id);
});
workingRows<Identification>('identification', [...store.getState().identifications.getMappingFor('attachments', document.id)]).filter(identificationTemp => identificationTemp.attachments?.includes(document.id)).forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
if (_identification.status === 'D') return;
_identification.status = 'U';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
_identification.attachments = _identification.attachments?.filter(id => id !== document.id) || [];

_work.set('identification:' + _identification.id, _identification);
dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification), 'identification:' + _identification.id);
});
const deleted = document.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.DocumentActions.removeDocumentQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceDocument(document: Document, replaceWith: Document, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = document.id;}
const _work = workingSet();
workingRows<Firm>('firm', [...store.getState().firms.getMappingFor('logo', document.id)]).filter(firmTemp => firmTemp.logo === document.id).forEach(firmTemp => {
const _firm = ((_work.get('firm:' + firmTemp.id) ?? firmTemp) as Firm).clone();
if (_firm.status === 'D') return;
_firm.status = 'U';
_firm.addedOn = newHRTimestamp();
_firm.addedBy = getCurrentUserId();
_firm.importSource = targetImportSource;
_firm.importId = mergeId;
if (_firm.logo === document.id) {
_firm.logo = replaceWith.id;

}
_work.set('firm:' + _firm.id, _firm);
store.dispatch(Actions.FirmActions.saveFirmQueue(_firm));
});
workingRows<Identification>('identification', [...store.getState().identifications.getMappingFor('attachments', document.id)]).filter(identificationTemp => identificationTemp.attachments?.includes(document.id)).forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
if (_identification.status === 'D') return;
_identification.status = 'U';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
_identification.attachments = _identification.attachments?.map(id => (id === document.id) ? replaceWith.id : id) || [];

_work.set('identification:' + _identification.id, _identification);
store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
});



return document;
}
